"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8187],{

/***/ 49911:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Vq": function() { return /* reexport */ SocialMedia_FacebookIcon; },
  "ET": function() { return /* reexport */ SocialMedia_GithubIcon; },
  "pA": function() { return /* reexport */ SocialMedia_LinkedinIcon; },
  "Zm": function() { return /* reexport */ SocialMedia_TwitterIcon; }
});

// EXTERNAL MODULE: ../../libs/matcha/components/Icons/utils/createIconsComponent.tsx + 1 modules
var createIconsComponent = __webpack_require__(37699);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ../../libs/matcha/components/Icons/components/SocialMedia/FacebookIcon.tsx
/*!
 * ==============================================================
 * This file is generated automatically by the generator.
 * DO NOT UPDATE IT MANUALLY!
 * ==============================================================
 */


var FacebookIcon = (0,createIconsComponent/* default */.Z)((0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("svg", {
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
    d: "M12.4468 19.9792C12.45 19.9497 12.4516 19.9196 12.4516 19.8893V12.6865H14.9133C15.308 12.6865 15.6633 12.4265 15.721 12.036C15.8164 11.39 15.7759 10.8026 15.7141 10.3849C15.6575 10.0014 15.3158 9.74892 14.9282 9.74892H12.4516C12.4516 7.52919 12.8209 7.2062 14.9026 7.1658C15.302 7.15806 15.6606 6.89428 15.7186 6.49892C15.816 5.83436 15.7772 5.25373 15.716 4.84525C15.6596 4.46794 15.3213 4.22199 14.9399 4.22532C11.2606 4.25742 9.16502 4.69252 9.16502 9.74892H7.25889C6.88845 9.74892 6.55956 9.98114 6.50351 10.3474C6.44316 10.742 6.40667 11.3139 6.50742 12.0096C6.56564 12.4115 6.92707 12.6865 7.33311 12.6865H9.16502V20.0008C6.31613 19.9821 4.27698 19.8696 2.9492 19.7617C1.48793 19.643 0.360453 18.5153 0.241729 17.0538C0.123591 15.5995 0 13.2919 0 10.0018C0 6.71167 0.123591 4.40402 0.241729 2.94972C0.360453 1.48819 1.48793 0.360517 2.9492 0.241772C4.40324 0.123608 6.71049 0 10 0C13.2895 0 15.5968 0.123613 17.0508 0.241772C18.512 0.360517 19.6396 1.4882 19.7583 2.94972C19.8764 4.40402 20 6.71167 20 10.0018C20 13.2919 19.8764 15.5995 19.7583 17.0538C19.6396 18.5154 18.512 19.643 17.0508 19.7617C15.9884 19.8481 14.4705 19.9373 12.4468 19.9792Z",
    fill: "none"
  })
}), 'FacebookIcon', 'SocialMedia');
/* harmony default export */ var SocialMedia_FacebookIcon = (FacebookIcon);
;// CONCATENATED MODULE: ../../libs/matcha/components/Icons/components/SocialMedia/GithubIcon.tsx
/*!
 * ==============================================================
 * This file is generated automatically by the generator.
 * DO NOT UPDATE IT MANUALLY!
 * ==============================================================
 */


var GithubIcon = (0,createIconsComponent/* default */.Z)((0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("svg", {
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 8.073C0 3.483 3.423 0 7.897 0C12.371 0 16 3.484 16 8.073C16 11.742 13.813 14.882 10.587 15.98C10.177 16.056 10.029 15.795 10.029 15.58L10.031 14.997C10.034 14.426 10.039 13.56 10.039 12.814C10.039 12.036 9.787 11.54 9.49 11.279C11.293 11.07 13.194 10.815 13.194 7.623C13.194 6.716 12.877 6.26 12.361 5.674C12.445 5.459 12.719 4.576 12.277 3.428C11.603 3.209 10.052 4.321 10.052 4.321C9.39292 4.13403 8.71108 4.03946 8.026 4.04C7.339 4.04 6.646 4.136 6 4.32C6 4.32 4.448 3.213 3.774 3.428C3.332 4.572 3.606 5.459 3.69 5.674C3.174 6.256 2.929 6.713 2.929 7.623C2.929 10.806 4.749 11.073 6.552 11.279C6.319 11.497 6.11 11.864 6.035 12.393C5.575 12.612 4.39 12.979 3.684 11.703C3.242 10.915 2.439 10.849 2.439 10.849C1.649 10.839 2.387 11.358 2.387 11.358C2.917 11.606 3.284 12.568 3.284 12.568C3.758 14.051 6.016 13.555 6.016 13.555C6.0168 14.232 6.02013 14.909 6.026 15.586C6.026 15.801 5.881 16.063 5.468 15.986C2.252 14.883 0 11.742 0 8.073ZM4.487 12.896C4.39 12.876 4.326 12.8 4.348 12.734C4.371 12.668 4.464 12.634 4.548 12.658C4.645 12.688 4.706 12.764 4.688 12.83C4.668 12.896 4.571 12.93 4.488 12.896H4.487ZM5.184 13.002C5.277 13.002 5.352 12.949 5.352 12.882C5.352 12.807 5.268 12.754 5.171 12.764C5.077 12.764 5.003 12.817 5.003 12.883C5.003 12.959 5.077 13.012 5.183 13.002H5.184ZM5.774 12.678C5.681 12.701 5.616 12.764 5.626 12.84C5.636 12.906 5.72 12.95 5.816 12.926C5.91 12.903 5.974 12.84 5.965 12.774C5.955 12.711 5.868 12.668 5.775 12.678H5.774ZM3.135 11.41C3.094 11.444 3.103 11.52 3.158 11.582C3.21 11.635 3.284 11.658 3.326 11.616C3.368 11.582 3.358 11.506 3.303 11.443C3.252 11.39 3.177 11.367 3.135 11.41ZM2.861 11.27C2.797 11.238 2.764 11.185 2.787 11.142C2.81 11.109 2.861 11.099 2.926 11.119C2.99 11.152 3.023 11.205 3 11.248C2.977 11.294 2.913 11.304 2.861 11.271V11.27ZM3.832 12.32C3.781 12.362 3.8 12.462 3.874 12.524C3.948 12.6 4.042 12.61 4.084 12.558C4.126 12.515 4.106 12.415 4.042 12.352C3.971 12.276 3.874 12.266 3.832 12.319V12.32ZM3.465 12.028C3.413 11.952 3.413 11.866 3.465 11.833C3.516 11.79 3.6 11.823 3.645 11.899C3.697 11.975 3.697 12.061 3.645 12.104C3.603 12.137 3.516 12.104 3.465 12.028Z",
    fill: "none"
  })
}), 'GithubIcon', 'SocialMedia');
/* harmony default export */ var SocialMedia_GithubIcon = (GithubIcon);
;// CONCATENATED MODULE: ../../libs/matcha/components/Icons/components/SocialMedia/LinkedinIcon.tsx
/*!
 * ==============================================================
 * This file is generated automatically by the generator.
 * DO NOT UPDATE IT MANUALLY!
 * ==============================================================
 */


var LinkedinIcon = (0,createIconsComponent/* default */.Z)((0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("svg", {
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.14 0H14.857C15.1615 0.00185152 15.4528 0.124378 15.6671 0.340709C15.8813 0.557041 16.0011 0.849518 16 1.154V14.846C16.0011 15.1505 15.8813 15.443 15.6671 15.6593C15.4528 15.8756 15.1615 15.9981 14.857 16H1.14C0.511 16 0 15.482 0 14.846V1.154C0 0.518 0.51 0 1.14 0ZM2.464 13.714H4.84V6.08H2.464V13.715V13.714ZM3.65 5.035C3.2944 5.02144 2.95789 4.87063 2.7111 4.61425C2.46431 4.35788 2.32645 4.01586 2.32645 3.66C2.32645 3.30414 2.46431 2.96212 2.7111 2.70574C2.95789 2.44937 3.2944 2.29856 3.65 2.285C4.407 2.285 5.025 2.903 5.025 3.66C5.025 4.42 4.411 5.035 3.65 5.035ZM11.354 13.714H13.725V9.528C13.725 7.471 13.278 5.888 10.879 5.888C9.725 5.888 8.949 6.521 8.632 7.121H8.6V6.078H6.325V13.714H8.696V9.935C8.696 8.939 8.886 7.975 10.121 7.975C11.336 7.975 11.353 9.114 11.353 9.999V13.714H11.354Z",
    fill: "none"
  })
}), 'LinkedinIcon', 'SocialMedia');
/* harmony default export */ var SocialMedia_LinkedinIcon = (LinkedinIcon);
;// CONCATENATED MODULE: ../../libs/matcha/components/Icons/components/SocialMedia/TwitterIcon.tsx
/*!
 * ==============================================================
 * This file is generated automatically by the generator.
 * DO NOT UPDATE IT MANUALLY!
 * ==============================================================
 */


var TwitterIcon = (0,createIconsComponent/* default */.Z)((0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("svg", {
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
    d: "M14.355 4.74001C14.365 4.88201 14.365 5.02401 14.365 5.16601C14.365 9.50301 11.066 14.5 5.035 14.5C3.2498 14.5044 1.50135 13.9929 0 13.027C0.264 13.057 0.518 13.068 0.792 13.068C2.26801 13.0715 3.70216 12.5776 4.863 11.666C4.17863 11.6535 3.51526 11.4275 2.96557 11.0196C2.41589 10.6118 2.00734 10.0424 1.797 9.39101C2 9.42101 2.203 9.44201 2.417 9.44201C2.711 9.44201 3.005 9.40201 3.279 9.33001C2.53627 9.1796 1.86854 8.77666 1.38927 8.18966C0.910009 7.60265 0.648787 6.86781 0.65 6.11001V6.07001C1.087 6.31401 1.595 6.46601 2.133 6.48701C1.68273 6.18762 1.31352 5.78149 1.05826 5.30482C0.802995 4.82814 0.669615 4.29573 0.67 3.75501C0.67 3.14501 0.832 2.58701 1.117 2.09901C1.94043 3.11309 2.96784 3.94275 4.13259 4.53417C5.29734 5.12558 6.5734 5.46555 7.878 5.53201C7.82542 5.28476 7.79828 5.03278 7.797 4.78001C7.79674 4.3492 7.8814 3.92256 8.04614 3.52449C8.21088 3.12643 8.45247 2.76474 8.7571 2.46011C9.06173 2.15548 9.42342 1.91389 9.82149 1.74915C10.2196 1.5844 10.6462 1.49974 11.077 1.50001C11.5259 1.49904 11.9703 1.59052 12.3823 1.76876C12.7944 1.94699 13.1653 2.20817 13.472 2.53601C14.2063 2.39454 14.9104 2.12656 15.553 1.74401C15.3088 2.50199 14.7964 3.14485 14.112 3.55201C14.772 3.48101 15.412 3.29801 16 3.04401C15.551 3.69785 14.9948 4.27124 14.355 4.74001Z",
    fill: "none"
  })
}), 'TwitterIcon', 'SocialMedia');
/* harmony default export */ var SocialMedia_TwitterIcon = (TwitterIcon);
;// CONCATENATED MODULE: ../../libs/matcha/components/Icons/SocialMedia.ts
/*!
 * ==============================================================
 * This file is generated automatically by the generator.
 * DO NOT UPDATE IT MANUALLY!
 * ==============================================================
 */





/***/ }),

/***/ 80653:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "V": function() { return /* reexport */ Content; },
  "Z": function() { return /* reexport */ Footer_Footer; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../libs/matcha/foundations/AppearanceContext/index.ts + 1 modules
var AppearanceContext = __webpack_require__(9381);
// EXTERNAL MODULE: ../../libs/matcha/foundations/Theme/index.ts + 30 modules
var Theme = __webpack_require__(46630);
// EXTERNAL MODULE: ../../libs/matcha/components/Icons/SocialMedia.ts + 4 modules
var SocialMedia = __webpack_require__(49911);
// EXTERNAL MODULE: ../../libs/matcha/useDesignTokens/index.ts
var useDesignTokens = __webpack_require__(98439);
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
// EXTERNAL MODULE: ../../libs/matcha/components/ColumnTrack/index.ts + 2 modules
var components_ColumnTrack = __webpack_require__(85735);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Footer/MenuList.views.tsx


function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}


var Menu = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(components_ColumnTrack/* default */.Z,  true ? {
  target: "eu0wj3i6"
} : 0)( true ? "" : 0);
var MenuColumn = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "eu0wj3i5"
} : 0)( true ? "" : 0);
var MenuTitle = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("p",  true ? {
  target: "eu0wj3i4"
} : 0)(function (_ref) {
  var theme = _ref.theme;
  return theme.typography.textBold;
}, ";color:", function (_ref2) {
  var titleColor = _ref2.titleColor;
  return titleColor;
}, ";margin-bottom:28px;white-space:nowrap;" + ( true ? "" : 0));
var MenuItem = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("li",  true ? {
  target: "eu0wj3i3"
} : 0)( true ? "" : 0);
var MenuLink = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("a",  true ? {
  target: "eu0wj3i2"
} : 0)(function (_ref3) {
  var theme = _ref3.theme;
  return theme.typography.textRegularSmall;
}, " color:", function (_ref4) {
  var linkColor = _ref4.linkColor;
  return linkColor;
}, ";text-decoration:none;transition:color 0.3s ease;:hover{color:", function (_ref5) {
  var linkHoverColor = _ref5.linkHoverColor;
  return linkHoverColor;
}, ";}" + ( true ? "" : 0));
var MenuLinks = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("ul",  true ? {
  target: "eu0wj3i1"
} : 0)( true ? {
  name: "1gh8jp",
  styles: "display:grid;grid-gap:20px;padding:0;list-style:none"
} : 0);
var MenuList = /*#__PURE__*/(/* unused pure expression or super */ null && (_styled(ColumnTrack,  true ? {
  target: "eu0wj3i0"
} : 0)( true ? "" : 0)));
/* harmony default export */ var MenuList_views = ((/* unused pure expression or super */ null && (MenuList)));
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Footer/MenuList.tsx


function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}







var MenuList_MenuList = function MenuList(_ref) {
  var mainLinks = _ref.mainLinks,
      tokens = _ref.tokens;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Menu, {
    columns: 1,
    overrides: {
      sm: 2,
      md: 4
    },
    children: mainLinks.map(function (_ref2) {
      var title = _ref2.title,
          links = _ref2.links;
      return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(MenuColumn, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MenuTitle, _objectSpread(_objectSpread({}, tokens), {}, {
          children: title
        })), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MenuLinks, {
          children: links.map(function (_ref3) {
            var title = _ref3.title,
                url = _ref3.url,
                rel = _ref3.rel;
            return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MenuItem, {
              children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MenuLink, _objectSpread(_objectSpread({}, tokens), {}, {
                href: url,
                rel: rel,
                children: title
              }))
            }, title);
          })
        })]
      }, title);
    })
  });
};

/* harmony default export */ var Footer_MenuList = ((0,useDesignTokens/* withDesignTokens */.Y)(MenuList_MenuList, function () {
  return {
    titleColor: Theme/* default.palette.brand.darkAcai.700 */.ZP.palette.brand.darkAcai[700],
    linkColor: Theme/* default.palette.brand.darkAcai.500 */.ZP.palette.brand.darkAcai[500],
    linkHoverColor: Theme/* default.palette.brand.darkAcai.700 */.ZP.palette.brand.darkAcai[700]
  };
}, {
  light: function light(theme) {
    return {
      titleColor: theme.palette.brand.darkAcai[700],
      linkColor: theme.palette.brand.darkAcai[500],
      linkHoverColor: theme.palette.brand.darkAcai[700]
    };
  },
  dark: function dark(theme) {
    return {
      titleColor: theme.palette.neutrals.white[100],
      linkColor: theme.palette.brand.darkAcai[400],
      linkHoverColor: theme.palette.neutrals.white[100]
    };
  },
  twilioLight: function twilioLight(theme) {
    return {
      titleColor: theme.palette.neutrals.white[100],
      linkColor: theme.palette.twilio.gray[20],
      linkHoverColor: theme.palette.neutrals.white[100]
    };
  }
}));
// EXTERNAL MODULE: ../../libs/matcha/recipes/Footer/useTrustArcLink.ts
var useTrustArcLink = __webpack_require__(9642);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Footer/Footer.views.tsx


function Footer_views_EMOTION_STRINGIFIED_CSS_ERROR_() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}


var Footer = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("footer",  true ? {
  target: "eb70auz13"
} : 0)("position:relative;padding:40px 40px 0;background:", function (_ref) {
  var backgroundColor = _ref.backgroundColor;
  return backgroundColor;
}, ";", function (_ref2) {
  var theme = _ref2.theme;
  return theme.breakpoints.up("md");
}, "{padding:80px 80px 0;}" + ( true ? "" : 0));
var Footer_views_MenuItem = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("li",  true ? {
  target: "eb70auz12"
} : 0)("display:inline-block;margin-right:32px;margin-bottom:32px;width:100%;margin-right:0;", function (_ref3) {
  var theme = _ref3.theme;
  return theme.breakpoints.up("sm");
}, "{width:50%;}", function (_ref4) {
  var theme = _ref4.theme;
  return theme.breakpoints.up("md");
}, "{width:auto;margin-right:32px;}" + ( true ? "" : 0));
var Footer_views_MenuLink = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("a",  true ? {
  target: "eb70auz11"
} : 0)(function (_ref5) {
  var theme = _ref5.theme;
  return theme.typography.textRegularSmall;
}, " color:", function (_ref6) {
  var linkColor = _ref6.linkColor;
  return linkColor;
}, ";display:grid;text-align:left;text-decoration:none;white-space:nowrap;transition:color 0.3s ease;:hover{color:", function (_ref7) {
  var linkHoverColor = _ref7.linkHoverColor;
  return linkHoverColor;
}, ";}" + ( true ? "" : 0));
var MenuLinkTrustArc = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("span",  true ? {
  target: "eb70auz10"
} : 0)(function (_ref8) {
  var theme = _ref8.theme;
  return theme.typography.textRegularSmall;
}, " a{color:", function (_ref9) {
  var linkColor = _ref9.linkColor;
  return linkColor;
}, ";display:grid;text-align:left;text-decoration:none;white-space:nowrap;transition:color 0.3s ease;:hover{color:", function (_ref10) {
  var linkHoverColor = _ref10.linkHoverColor;
  return linkHoverColor;
}, ";}}" + ( true ? "" : 0));
var Copyright = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("p",  true ? {
  target: "eb70auz9"
} : 0)(function (_ref11) {
  var theme = _ref11.theme;
  return theme.typography.textRegularSmall;
}, " color:", function (_ref12) {
  var linkColor = _ref12.linkColor;
  return linkColor;
}, ";display:grid;text-align:left;text-decoration:none;white-space:nowrap;" + ( true ? "" : 0));
var SocialLinks = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("ul",  true ? {
  target: "eb70auz8"
} : 0)( true ? {
  name: "1i4xymy",
  styles: "display:grid;width:80px;padding:0;margin:0 auto 0 0;grid-auto-flow:column;grid-gap:16px;list-style:none;margin-bottom:32px"
} : 0);
var SocialItem = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("li",  true ? {
  target: "eb70auz7"
} : 0)("color:", function (_ref13) {
  var linkColor = _ref13.linkColor;
  return linkColor;
}, ";" + ( true ? "" : 0));
var Content = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "eb70auz6"
} : 0)( true ? {
  name: "29dvht",
  styles: "margin:auto;max-width:1028px"
} : 0);
var FooterTop = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(components_ColumnTrack/* default */.Z,  true ? {
  target: "eb70auz5"
} : 0)( true ? {
  name: "ggfeg7",
  styles: "margin-bottom:64px"
} : 0);
var LogoSlot = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "eb70auz4"
} : 0)( true ? {
  name: "lydbna",
  styles: "max-width:150px;max-height:40px;align-self:center"
} : 0);
var CtaSlot = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "eb70auz3"
} : 0)("max-width:440px;", function (_ref14) {
  var theme = _ref14.theme;
  return theme.breakpoints.up("sm");
}, "{margin-left:auto;}" + ( true ? "" : 0));
var FooterContent = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "eb70auz2"
} : 0)( true ? {
  name: "ggfeg7",
  styles: "margin-bottom:64px"
} : 0);
var FooterBottom = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "eb70auz1"
} : 0)( true ? {
  name: "hbkq8l",
  styles: "display:flex;justify-content:space-between;flex-wrap:wrap;position:relative;padding-top:32px;&::before{content:'';position:absolute;top:0;left:0;width:100%;height:1px;background:radial-gradient(circle, rgba(255, 255, 255, 0.25) 0%, rgba(255, 255, 255, 0) 113%);}"
} : 0);
var BottomLinks = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("ul",  true ? {
  target: "eb70auz0"
} : 0)("padding:0;list-style:none;display:inline-block;flex-grow:1;", function (_ref15) {
  var theme = _ref15.theme;
  return theme.breakpoints.up("md");
}, "{min-width:610px;}" + ( true ? "" : 0));
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Footer/Footer.tsx


function Footer_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function Footer_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? Footer_ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Footer_ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}











var FooterBase = function FooterBase(_ref) {
  var cta = _ref.cta,
      logo = _ref.logo,
      mainLinks = _ref.mainLinks,
      bottomLinks = _ref.bottomLinks,
      copyright = _ref.copyright,
      externalAppearance = _ref.appearance,
      className = _ref.className,
      tokens = _ref.tokens;
  var appearance = (0,AppearanceContext/* useAppearance */.M)(externalAppearance);
  var hasTrustArcEnabled = (0,useTrustArcLink/* default */.Z)();
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AppearanceContext/* AppearanceProvider */.x, {
    appearance: appearance,
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Footer, Footer_objectSpread(Footer_objectSpread({
      className: className
    }, tokens), {}, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Content, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(FooterTop, {
          columns: 1,
          overrides: {
            sm: 2
          },
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LogoSlot, {
            children: logo
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CtaSlot, {
            children: cta
          })]
        }), mainLinks && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FooterContent, {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Footer_MenuList, {
            mainLinks: mainLinks
          })
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(FooterBottom, {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(BottomLinks, {
            children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Footer_views_MenuItem, {
              children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Copyright, Footer_objectSpread(Footer_objectSpread({}, tokens), {}, {
                children: copyright
              }))
            }), bottomLinks.map(function (_ref2) {
              var title = _ref2.title,
                  url = _ref2.url;
              return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Footer_views_MenuItem, {
                children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Footer_views_MenuLink, Footer_objectSpread(Footer_objectSpread({}, tokens), {}, {
                  href: url,
                  children: title
                }))
              }, title);
            }), hasTrustArcEnabled && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Footer_views_MenuItem, {
              children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MenuLinkTrustArc, Footer_objectSpread(Footer_objectSpread({}, tokens), {}, {
                id: "teconsent"
              }))
            })]
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(SocialLinks, {
            children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SocialItem, Footer_objectSpread(Footer_objectSpread({}, tokens), {}, {
              children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Footer_views_MenuLink, Footer_objectSpread(Footer_objectSpread({}, tokens), {}, {
                href: "https://www.linkedin.com/company/segment-io",
                children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SocialMedia/* LinkedinIcon */.pA, {
                  size: "small",
                  label: "Linkedin"
                })
              }))
            })), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SocialItem, Footer_objectSpread(Footer_objectSpread({}, tokens), {}, {
              children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Footer_views_MenuLink, Footer_objectSpread(Footer_objectSpread({}, tokens), {}, {
                href: "https://twitter.com/segment",
                children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SocialMedia/* TwitterIcon */.Zm, {
                  size: "small",
                  label: "Twitter"
                })
              }))
            })), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SocialItem, Footer_objectSpread(Footer_objectSpread({}, tokens), {}, {
              children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Footer_views_MenuLink, Footer_objectSpread(Footer_objectSpread({}, tokens), {}, {
                href: "https://github.com/segmentio",
                children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SocialMedia/* GithubIcon */.ET, {
                  size: "small",
                  label: "Github"
                })
              }))
            }))]
          })]
        })]
      })
    }))
  });
};

var Footer_Footer = (0,useDesignTokens/* withDesignTokens */.Y)(FooterBase, function () {
  return {
    backgroundColor: Theme/* default.palette.neutrals.cloud.100 */.ZP.palette.neutrals.cloud[100],
    linkColor: Theme/* default.palette.brand.darkAcai.400 */.ZP.palette.brand.darkAcai[400],
    linkHoverColor: Theme/* default.palette.brand.darkAcai.800 */.ZP.palette.brand.darkAcai[800]
  };
}, {
  light: function light(theme) {
    return {
      backgroundColor: theme.palette.neutrals.cloud[100],
      linkColor: theme.palette.brand.darkAcai[400],
      linkHoverColor: theme.palette.brand.darkAcai[800]
    };
  },
  dark: function dark(theme) {
    return {
      backgroundColor: theme.palette.brand.darkAcai[700],
      linkColor: theme.palette.brand.darkAcai[400],
      linkHoverColor: theme.palette.neutrals.white[100]
    };
  },
  twilioLight: function twilioLight(theme) {
    return {
      backgroundColor: theme.palette.twilio.gray[100],
      linkColor: theme.palette.twilio.gray[20],
      linkHoverColor: theme.palette.neutrals.white[100]
    };
  },
  cdpWeek2023: function cdpWeek2023(theme) {
    return {
      backgroundColor: theme.palette.cdpWeek2023.gray[100],
      linkColor: theme.palette.cdpWeek2023.gray[20],
      linkHoverColor: theme.palette.neutrals.white[100]
    };
  }
});
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Footer/index.ts



/***/ })

}]);